export const DEV_API_URL = process.env.VUE_APP_DEV_API_URL || '//localhost:57775/api'
export const STAGE_API_URL = '//timetracker.ctidemo.us/api'
export const PROD_API_URL = '//timetrackerapi.cticonsulting.net/api'

export const PATH_ASSIGNMENTS = 'assignments'
export const PATH_ASSIGNMENTS_BY_USER_ID = PATH_ASSIGNMENTS + '/assignmentsbyuserid'
export const PATH_AUTHENTICATION = 'userAuthentication'
export const PATH_BILLING_RATE_TYPES = 'billRateTypes'
export const PATH_CLIENTS = 'clients'
export const PATH_COMMISSION_DETAILS_REPORT = 'commissionDetailsReport'
export const PATH_COMMISSION_REPORT = 'CommissionsReport'
export const PATH_COMMISSIONS_TIERS = 'commissionTiers'
export const PATH_CONTRACT_TYPES = 'contractTypes'
export const PATH_DASHBOARD_LAYOUT = 'dashboardLayout'
export const PATH_DASHBOARD = 'dashboard'
export const PATH_DASHBOARD_HEADCOUNT = PATH_DASHBOARD + '/headcount'
export const PATH_DASHBOARD_NTS = PATH_DASHBOARD + '/nts'
export const PATH_DASHBOARD_NTS_BY_EMPLOYEE = PATH_DASHBOARD + '/ntsbyemployee'
export const PATH_DASHBOARD_PLACEMENT_GOAL = PATH_DASHBOARD + '/placementgoal'
export const PATH_DASHBOARD_PERM_PLACEMENT_GOAL = PATH_DASHBOARD + '/permanentplacementgoal'
export const PATH_DASHBOARD_LABOR_EFFICIENCY_RATIO = PATH_DASHBOARD + '/laborefficiencyratio'
export const PATH_DASHBOARD_REVENUE_DATA = PATH_DASHBOARD + '/revenuedata'
export const PATH_DASHBOARD_UPCOMING_INTERVIEWS = PATH_DASHBOARD + '/upcominginterviews'
export const PATH_DASHBOARD_RECRUITERS_PERFORMANCE_DETAILS = PATH_DASHBOARD + '/recruitersperformancedetails'
export const PATH_DASHBOARD_GROSS_PROFIT_DETAILS_BY_MONTH = PATH_DASHBOARD + '/grossprofitbymonth'
export const PATH_DASHBOARD_GROSS_PROFIT_DETAILS_BY_YEAR = PATH_DASHBOARD + '/grossprofitbyyear'
export const PATH_DEAL_ASSIGNMENT = 'dealAssignments'
export const PATH_DEAL_CANDIDATES = 'dealCandidates'
export const PATH_DEAL_CLIENTS = 'dealClients'
export const PATH_DEAL_STATUSES = 'dealStatuses'
export const PATH_DEALS = 'deals'
export const PATH_DIRECT_PLACEMENT_GOALS = 'directPlacementGoals'
export const PATH_DIRECT_PLACEMENT_PAYMENTS = 'directPlacementsPayments'
export const PATH_DIRECT_PLACEMENTS = 'directPlacements'
export const PATH_EMPLOYEE_PAYROLL_TYPES = 'employeePayrollTypes'
export const PATH_EMPLOYEE_TYPES = 'employeeTypes'
export const PATH_EXPENSE_AMOUNT_TYPES = 'expenseAmountTypes'
export const PATH_EXPENSES_TYPES = 'expensesTypes'
export const PATH_GP_TO_COST_REPORT = 'grossProfitVSCostReport'
export const PATH_INVOICE_FREQUENCIES = 'InvoiceFrequencies'
export const PATH_INVOICE_REPORT = 'invoicingReport'
export const PATH_ONE_OFF_EXPENSES_RECORDS = 'OneOffFeesRecords'
export const PATH_OVERTIME_ENTRIES = 'overtimeEntries'
export const PATH_PAYMENT_FREQUENCIES = 'payFrequencies'
export const PATH_PAYMENT_RATE_TYPES = 'payRateTypes'
export const PATH_PAYROLL_REPORT = 'payrollReport'
export const PATH_PLACEMENT_GOALS = 'placementGoals'
export const PATH_RESETPASSWORD = 'userResetPassword'
export const PATH_SETTINGS = 'settings'
export const PATH_STAFF = 'staff'
export const PATH_TEAMS = 'teams'
export const PATH_THIRD_PARTY_PORTALS = 'ThirdPartyPortals'
export const PATH_TIME_CARD_REPORT = 'timeCardReport'
export const PATH_CONSULTANT_TIME_SHEET = 'consultantTimesheet'
export const PATH_STAFF_TIME_SHEET = 'staffTimesheet'
export const PATH_TODO_GROUPS = 'todoGroups'
export const PATH_TODO_NOTES = 'todoNotes'
export const PATH_USER_ASSIGNMENTS = 'userAssignments'
export const PATH_USER_PASSWORDS = 'userPasswords'
export const PATH_USER_TODOS = 'todos'
export const PATH_USERS = 'users'
export const PATH_ZR_JOB_OPENINGS = 'zRJobOpenings'
export const PATH_BIWEEKLY_PERIODS = 'biweeklyPeriods'
export const PATH_PERIODS = 'periods'
export const PATH_REVENUE_DATA = 'revenueData'
export const PATH_CONSULTANTS_EDITED_TOTAL_PAY = 'consultantsEditedTotalPay'
export const PATH_STAFF_EDITED_TOTAL_PAY = 'staffEditedTotalPay'
export const PATH_EDITED_TOTAL_BILL = 'editedTotalBill'
export const PATH_CLOCK_LOGS = 'clockLogs'
export const PATH_DATETIME_HELPER = 'datetimehelper'
export const PATH_GET_UTC_TIME = PATH_DATETIME_HELPER + '/getutctime'
export const PATH_GET_STAFFLYNX_TIME = PATH_DATETIME_HELPER + '/getstafflynxtime'
export const PATH_GET_STAFFLYNX_CURRENT_WEEK_DATE_RANGE = PATH_DATETIME_HELPER + '/getstafflynxcurrentweekdaterange'
export const PATH_CLOCK_LOGS_REPORT = 'clockLogsReport'
export const PATH_TIME_MANAGEMENT = 'timeManagement'
export const PATH_CONSULTANTS_TIME_MANAGEMENT = PATH_TIME_MANAGEMENT + '/getassignmentstimesheetentries'
export const PATH_STAFF_TIME_MANAGEMENT = PATH_TIME_MANAGEMENT + '/getstafftimesheetentries'
